
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";


export default class DetailPicture extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};


    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let {detailData = {}} = this.props;
        let {storageFile = {}} = detailData;
        let {path = ""} = storageFile;
        return (
            <div style={{width: '100%', height: '100%', display: 'flex'}}>
                <img src={path} style={{maxWidth: '100%', maxHeight: "100%",  margin: 'auto'}}
                     id={this.props.id}/>
            </div>
        )
    }
}